import { render, staticRenderFns } from "./liveplayer.vue?vue&type=template&id=7a8da2b6&lang=true"
import script from "./liveplayer.vue?vue&type=script&lang=js"
export * from "./liveplayer.vue?vue&type=script&lang=js"
import style0 from "./liveplayer.vue?vue&type=style&index=0&id=7a8da2b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports